import {
  isRouteErrorResponse,
  Link,
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
  type MetaFunction,
} from 'react-router';

import type { Route } from './+types/root';
import { LogoMark } from './components/logo';
import './app.css';

export const meta: MetaFunction = () => [
  { name: 'robots', content: 'index, follow' },
  { name: 'theme-color', content: '#16A34A' },
];

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32.png" />
        <link rel="icon" type="image/png" sizes="512x512" href="/favicon-512.png" />
        <link rel="apple-touch-icon" href="/apple-touch-icon.png" />
        <Meta />
        <Links />
      </head>
      <body>
        {children}
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}

export default function App() {
  return <Outlet />;
}

export function ErrorBoundary({ error }: Route.ErrorBoundaryProps) {
  let heading = 'Something went sideways.';
  let details = 'An unexpected error occurred. The calendar itself is fine — try again.';
  let code = 'Error';
  let stack: string | undefined;

  if (isRouteErrorResponse(error)) {
    code = String(error.status);
    if (error.status === 404) {
      heading = "That page isn't on the calendar.";
      details = 'The link may be old, or the event may have been removed.';
    } else {
      details = error.statusText || details;
    }
  } else if (import.meta.env.DEV && error && error instanceof Error) {
    details = error.message;
    stack = error.stack;
  }

  return (
    <main className="error-page">
      <LogoMark size={48} />
      <p className="error-code" aria-hidden="true">
        {code}
      </p>
      <h1>{heading}</h1>
      <p className="muted">{details}</p>
      {stack && <pre className="small error-stack">{stack}</pre>}
      <div className="row error-actions">
        <Link to="/" className="ui-btn btn-primary">
          Back to the calendar
        </Link>
        <Link to="/submit" className="ui-btn btn-secondary">
          List an event
        </Link>
      </div>
    </main>
  );
}
